import { Component } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import LenisProvider from "./components/LenisProvider";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import MasterTrading from "./pages/MasterTrading";
import StrategyTrading from "./pages/StrategyTrading";
import VaultTrading from "./pages/VaultTrading";
import VaultYield from "./pages/VaultYield";
import About from "./pages/About";
import Contact from "./pages/Contact";
import {
  RiskDisclosurePage,
  PrivacyPolicyPage,
  TermsPage,
  PerformanceMethodologyPage,
  CustodyPage,
  FeesTermsPage,
} from "./pages/LegalPages";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-ink-900 text-ink-50 px-6 text-center">
          <p className="font-display text-2xl font-bold">Something went wrong.</p>
          <p className="text-sm text-zinc-500">Please refresh the page to continue.</p>
          <a href="/" className="btn-gold mt-2">Back to Home</a>
        </div>
      );
    }
    return this.props.children;
  }
}

function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 px-6 text-center pt-24">
      <p className="font-mono text-xs tracking-[0.3em] text-gold-400/70 uppercase">404</p>
      <h1 className="font-display text-4xl font-bold tracking-tighter">Page not found.</h1>
      <p className="text-sm text-zinc-500 max-w-sm">
        The page you are looking for does not exist. Explore the four offerings instead.
      </p>
      <Link to="/" data-testid="notfound-home-link" className="btn-gold">
        Back to Home
      </Link>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <LenisProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="flex min-h-screen flex-col">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/master-trading" element={<MasterTrading />} />
                <Route path="/strategy-trading" element={<StrategyTrading />} />
                <Route path="/vault-trading" element={<VaultTrading />} />
                <Route path="/vault-yield" element={<VaultYield />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/risk-disclosure" element={<RiskDisclosurePage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-and-conditions" element={<TermsPage />} />
                <Route path="/performance-methodology" element={<PerformanceMethodologyPage />} />
                <Route path="/custody-and-asset-handling" element={<CustodyPage />} />
                <Route path="/fees-and-product-terms" element={<FeesTermsPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "rgba(10,10,14,0.95)",
                border: "1px solid rgba(255,193,7,0.25)",
                color: "#F4F4F5",
              },
            }}
          />
        </BrowserRouter>
      </LenisProvider>
    </ErrorBoundary>
  );
}